var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFacebook = props => /*#__PURE__*/React.createElement("svg", _extends({
  fill: "transparent",
  height: 24,
  viewBox: "0 0 24 24",
  width: 24,
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  clipRule: "evenodd",
  d: "m2 12.0558c0 4.9717 3.61083 9.1059 8.3333 9.9442v-7.2225h-2.49997v-2.7775h2.49997v-2.2225c0-2.5 1.6109-3.88833 3.8892-3.88833.7217 0 1.5.11083 2.2217.22166v2.55584h-1.2775c-1.2225 0-1.5.61083-1.5 1.38913v1.9442h2.6666l-.4441 2.7775h-2.2225v7.2225c4.7225-.8383 8.3333-4.9717 8.3333-9.9442 0-5.5308-4.5-10.0558-10-10.0558s-10 4.525-10 10.0558z",
  fillRule: "evenodd"
})));
export default SvgFacebook;